<template>
    <div>
        <loaderApp v-if="loader" />
        <detailUser :userDetails="userDetails" />
        <payment    :userDetails="userDetails" />
        <delivery   :userDetails="userDetails" />
        <alertApp />
    </div>
</template>

<script>

import alertApp from '@/components/common/alertApp.vue';
import loaderApp from '@/components/common/loaderApp.vue';
import detailUser from '@/components/account/details-page/Details-item.vue';
import delivery from '@/components/account/details-page/Delivery-item.vue'
import payment from '@/components/account/details-page/Payment-item.vue';

export default {
    name: 'myDetails',
    components: {
        detailUser,
        delivery,
        payment,
        loaderApp,
        alertApp
    },
    data() {
        return {            
        }
    },
    methods: {
    },
    computed: {
        loader() {
            return this.$store.getters.loader ?? false;
        },
        userDetails() {
          return this.$store.getters.userDetails;
        },
    },
    async beforeMount() {
        this.$store.dispatch('getUserDetails');
    },
    watch: {
    }
}
</script >

<style lang="stylus">
@import 'vuetify/dist/vuetify.min.css';
@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;700&display=swap');

* {
  box-sizing: border-box;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.v-btn--icon.v-btn--density-default,                     
.v-btn--elevated {
    box-shadow: none!important;
}

.v-ripple__container,
.v-field__outline,
.v-btn__overlay,
.v-field__overlay,
.v-btn__underlay {
  display: none!important;
}

.details-bg-grey {
    background: #F8F9FC;
    color: #1D2433;

    .row-data {
        padding: 2rem 0;
        border-bottom: 2px solid #E1E6EF;

        &.no-border,
        &:last-child,
        &:nth-child(5) {
            border-bottom: none;
        }

        &.payment {
            border-bottom: none;
            padding-bottom: .5rem;            
            position: relative;

            &:after {
                position: absolute;
                content: '';
                top: 1.6rem;
                left: 0;
                width: 40px;
                height: 40px;
                background: url(/src/assets/images/icons/card.svg) no-repeat center / 40px 40px;
            }

            .data-value,
            .data-key {
                padding-left: 70px;
            }
        }
        
        .data-key {
            color: #1D2433;
            font-family: 'Manrope', sans-serif;
            font-size: 18px;
            font-style: normal;
            font-weight: 800;
            line-height: 28px;
        }

        .data-value {
            color: #1D2433;
            font-family: 'Manrope', sans-serif;
            font-size: 18px;
            font-style: normal;
            font-weight: 400;
            line-height: 28px;
        }

        .data-edit {
            &.row-flex {
                gap: 0 2rem;
            }
        }
    }

    .row-card-data {
        gap: 0 2rem;
        margin-bottom: 1rem;

        & > div:first-child {
            width: 50%;
        }

        & > div:last-child {
            width: 50%;
        }
    }
}

.row-flex {
    .v-field__input {
        padding-top: 16px;
        padding-left: 0;
        padding-right: 0;

        input {
            margin: 0;
        }
    }

    .v-label {
        z-index: 100;
    }
}

.details-container {
  max-width: 600px;
  margin: 0 auto;
}

.row-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;

    p {
        display: inline-flex;
        align-items: center;

        svg {
            margin-right: 15px;
        }
    }
}

.block-page-title {
    padding: 2rem 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .btn-close {
        display: flex;
        justify-content: flex-end;

        svg {
            max-width: 15px;
            cursor: pointer;
            transition-duration: .4s

            &:hover {
                transform: scale(1.1);
            }
        }
    }

    h2 {
        color: #1D2433;
        font-family: 'Manrope', sans-serif;
        font-size: 26px;
        font-style: normal;
        font-weight: 800;
        line-height: normal;
        margin-bottom: .5rem;
    }

    p {
        color: #1D2433;
        font-family: Manrope;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        cursor: pointer;
        position: relative;
        transition-duration: .4s;

        &:after {
            position: absolute;
            content: '';
            bottom: -5px;
            left: 35px;
            height: 2px;
            background: #685bc7;
            width: 0;
            transition-duration: .4s;
        }

        &:hover {
            color: #685bc7;

            &:after {
                    width: calc(100% - 35px);
            }
        }
    }
}
.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition-duration: .4s;
  text-decoration: none;
  font-weight: 700;
  letter-spacing: normal;

  svg {
    margin-left: 15px;
  }

  &.btn-payment,
  &.btn-edit-delivery {
    width: 100%;
    height: 50px!important;
    background: #fff;
    color: #685BC7!important;
    border: 2px solid #685BC7;
    text-transform: none;
    border-radius: 10px;
    text-align: center;
    font-family: 'Manrope', sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: normal;

    svg {
      fill: #685BC7;
      transition-duration: .3s;
    }

    &:hover {
        background: #685BC7;
        color: #fff!important;

      svg {
        fill: #fff;     
      }
    }
  }



}

.data-key {
    text-transform: capitalize;
}

.btn-edit-meals {
    background: #685BC7;
    color: #fff;
    width: 100%;
    height: 50px!important;
    border: 2px solid #685BC7;
    text-transform: none;
    border-radius: 10px;
    text-align: center;
    font-family: 'Manrope', sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: normal;
    max-width: 400px;
    margin-left: auto;
    margin-right: auto;

    svg {
      fill: #fff;
      transition-duration: .3s;
    }

    &:hover {
        color: #685BC7;
        background: transparent;

        svg {
            fill: #685BC7;     
        }
    }
}

.block-delivery-data {
    padding-bottom: 2.5rem;

    & > .btn-close {
        margin-right: auto;
        text-align: right;

        svg {
            max-width: 15px;
            cursor: pointer;
            transition-duration: .4s

            &:hover {
                transform: scale(1.1);
            }
        }
    }

    &.delivery {
        padding-bottom: 5rem;
    }

    &.bg-block {
        background: url(/src/assets/images/icons/bg-block.svg) no-repeat top;
    }

    input {
        width: 100%;
        flex: none;
        min-width: 0;
        color: #201747;
        font-family: Manrope;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        border-radius: 10px!important;
        border: 2px solid #e1e6ef;
        height: 50px;
        padding: 10px 16px;
        min-height: 30px;
        margin-top: 1rem;
        opacity: 1!important;
    }
    
    label {
        margin-top: 12px;
    }

    .v-field--active label,
    .v-field--focused  label {
        margin-top: 0;
    }
}

.row-loader {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    background-color: rgba(250,250,250, 0.4);
    overflow: hidden;
    margin: 0!important;
}
.v-input__control {
    position: relative;

    span {
        position: absolute;
        right: 10px
        width: 24px;
        height: 24px;
        cursor: pointer;
        z-index: 100;
        background-size: cover!important;
        
        &.plus {
            top: 18px;
            transform: rotate(90deg);
            background: url(/src/assets/images/icons/arrow.svg) no-repeat center;
        }

        &.minus {
            bottom: 11px;
            transform: rotate(-90deg);
            background: url(/src/assets/images/icons/arrow.svg) no-repeat center;
        }
    }
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}

.v-btn.v-btn--disabled {
    opacity: 0.5 !important;
    cursor: not-allowed!important;
}
</style>